import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-categories',
  imports: [RouterModule],
  templateUrl: './user-categories.html',
  styleUrl: './user-categories.scss',
})
export class UserCategories {}
